import React, { useState } from 'react';
import { Box, Typography, Button, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Screen } from '../../components/Screen';
import ThemeOptions from '../OrganizationOnboardingScreen/components/ThemeOptions';
import CustomizationOptions from '../OrganizationOnboardingScreen/components/CustomizationOptions';
import ControlledAccordion from '../OrganizationOnboardingScreen/components/ControlledAccordion';

const UserSettingsScreen = () => {
  const theme = useTheme();
  const [formData, setFormData] = useState({
    // Theme Options
    primaryColor: '#196161',
    secondaryColor: '#E2A886',
    tertiaryColor: '',
    borderWidth: '',
    borderRadius: '',
    borderColor: '',
    boxShadow: '',

    // Customization Options
    customizationOptions: {
      useMetricSystem: false,
      showPoweredBy: false,
      skipHowItWorks: false,
      customMealPlans: false,
      showCODEQ: false,
      displayDIEMScores: false,
    },
  });

  const [tempTheme, setTempTheme] = useState({});

  const [sections, setSections] = useState([
    { name: 'Theme Options', open: false },
    { name: 'Customization Options', open: false },
  ]);

  const handleAccordionChange = (sectionName) => (event, isExpanded) => {
    setSections((prevSections) =>
      prevSections.map((section) => (section.name === sectionName ? { ...section, open: isExpanded } : section)),
    );
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleNestedChange = (section, field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [section]: {
        ...prevData[section],
        [field]: value,
      },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log('User settings submitted:', formData);
  };

  return (
    <Screen
      title="User Settings"
      showSidebarNav={true}
      admin={false}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Box sx={{ flex: 1, marginRight: '220px' }}>
          <Box
            component="form"
            sx={{ padding: 2, marginBottom: 2 }}
            onSubmit={handleSubmit}
          >
            <Typography
              variant="h4"
              sx={{ marginBottom: 2 }}
            >
              User Settings
            </Typography>

            <Grid
              container
              spacing={2}
            >
              {sections.map((section, index) => (
                <Grid
                  item
                  xs={12}
                  key={index}
                >
                  <ControlledAccordion
                    title={section.name}
                    description={`Configure the ${section.name.toLowerCase()} for your account`}
                    contents={
                      {
                        'Theme Options': (
                          <ThemeOptions
                            formData={formData}
                            handleChange={handleChange}
                            setTempTheme={setTempTheme}
                          />
                        ),
                        'Customization Options': (
                          <CustomizationOptions
                            formData={formData}
                            handleNestedChange={handleNestedChange}
                            tempTheme={tempTheme}
                          />
                        ),
                      }[section.name]
                    }
                    expanded={section.open}
                    onChange={handleAccordionChange(section.name)}
                  />
                </Grid>
              ))}
            </Grid>

            <Box sx={{ marginTop: 4 }}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
              >
                Save Settings
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Screen>
  );
};

export default UserSettingsScreen;
